module.exports = __webpack_public_path__ + "img/MP.8ed76091.png";